import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import CallV2 from "../../service/axiosV2";
import {getUrl} from "../../constants/urls";

export const getControllers = (
  {customerId, siteId, locationId},
  pageUrl = "",
  trackThisPromise = true
) => {
  const url = pageUrl
    ? pageUrl
    : getUrl("controllers_new_list")(customerId, siteId, locationId);
  if (trackThisPromise) {
    return trackPromise(Call.get(url));
  } else {
    return Call.get(url);
  }
};

export const getWifiConfigurations = ({mac_id}) => {
  const url = getUrl("wifi_configurations")(mac_id);
  return trackPromise(Call.get(url));
};

export const getTelemetryAsync = ({mac_id}) => {
  const url = getUrl("telemetry")(mac_id);
  return trackPromise(Call.get(url));
};

export const getSystemInventories = (trackThisPromise, {mac_id}) => {
  const url = getUrl("systemInventories")(mac_id);
  if (trackThisPromise) {
    return trackPromise(Call.get(url));
  } else {
    return Call.get(url);
  }
};

export const getIOTypesAsync = ({mac_id}) => {
  const url = getUrl("getIOTypes")(mac_id);
  return trackPromise(Call.get(url));
};

export const getProbesAsync = ({mac_id, ioType}) => {
  const url = getUrl("getProbesList")(mac_id, ioType);
  return trackPromise(Call.get(url));
};

export const getSensorListAsync = ({mac_id, IO_TYPE_PROBE, probe}) => {
  const url = getUrl("getSensorList")(mac_id, IO_TYPE_PROBE, probe);
  return trackPromise(Call.get(url));
};

export const getAvailablePinsAsync = ({mac_id, ioType, probeType, sensorId}) => {
  const url = getUrl("pins")(mac_id, ioType, probeType, sensorId);
  return trackPromise(Call.get(url));
};

export const createProbesAsync = ({mac_id, ioType, probeType, sensorId}, payload) => {
  const url = getUrl("pins")(mac_id, ioType, probeType, sensorId);
  return trackPromise(Call.post(url, payload));
};

export const getSummaryDataAsync = ({mac_id, trackThisPromise}) => {
  const url = getUrl("summary")(mac_id);
  if (trackThisPromise) {
    return trackPromise(CallV2.get(url));
  } else {
    return CallV2.get(url);
  }
};

export const getSummarySensorDataAsync = ({
  mac_id,
  sensor_id,
  trackThisPromise = true,
}) => {
  const url = getUrl("summarySensor")(mac_id, sensor_id);
  if (trackThisPromise) {
    return trackPromise(CallV2.get(url));
  } else {
    return CallV2.get(url);
  }
};

export const getSensorCalibrationCommandsAsync = ({mac_id, sensor_id}) => {
  const url = getUrl("calibrate")(mac_id, sensor_id);
  return trackPromise(Call.get(url));
};

export const runSensorCalibrationCommandsAsync = ({mac_id, sensor_id}, payload) => {
  const url = getUrl("calibrate")(mac_id, sensor_id);
  return trackPromise(Call.post(url, payload));
};

export const getSensorCalibrationHistoryAsync = ({
  mac_id,
  sensor_id,
  trackThisPromise,
}) => {
  const url = getUrl("calibrationHistory")(mac_id, sensor_id);
  if (trackThisPromise) {
    return trackPromise(Call.get(url));
  } else {
    return Call.get(url);
  }
};

// Need to be relocated.
export const getSensorDetailsAsync = ({mac_id, sensorId}, routeAction) => {
  const url = getUrl("sensorDetails")(mac_id, sensorId);
  if (routeAction === "Click") {
    return trackPromise(Call.get(url, {params: {read_only: true}}));
  } else {
    return trackPromise(Call.get(url));
  }
};

export const updateSensorDetailsAsync = ({mac_id, sensorId}, payload) => {
  const url = getUrl("sensorDetailsEdit")(mac_id, sensorId);
  return trackPromise(Call.post(url, payload));
};

export const deleteSensorDetailsAsync = ({mac_id, sensorId}) => {
  const url = getUrl("sensorDelete")(mac_id, sensorId);
  return trackPromise(Call.delete(url));
};

export const resetLimitSensorAsync = ({mac_id, sensorId}) => {
  const url = getUrl("resetLimit")(mac_id, sensorId);
  return trackPromise(Call.post(url));
};

export const acknowledgePowerOnOff = ({mac_id, sensorId}) => {
  const url = getUrl("acknowledgePower")(mac_id, sensorId);
  return trackPromise(Call.post(url));
};

export const requestTestFeedAsync = ({mac_id, sensorId}) => {
  const url = getUrl("testFeed")(mac_id, sensorId);
  // Empty payload
  return trackPromise(Call.post(url, {}));
};

export const requestAddSlugFeedAsync = ({mac_id, sensorId}, payload) => {
  const url = getUrl("addSlugFeed")(mac_id, sensorId);
  // Empty payload
  return trackPromise(Call.post(url, payload));
};

export const requestSystemLogsAsync = (mac, pageUrl, params = {}) => {
  const url = pageUrl ? pageUrl : getUrl("systemLogs")(mac);
  return trackPromise(Call.get(url, {params}));
};

export const requestSensorSummaryAsync = ({mac_id, sensor_id}) => {
  const url = getUrl("sensorSummary")(mac_id, sensor_id);
  return trackPromise(Call.get(url));
};

export const editController = ({mac_id}, payload) => {
  const url = getUrl("controller_edit")(mac_id);
  return trackPromise(Call.patch(url, payload));
};

export const requestAnalogBankAsync = ({mac_id}) => {
  const url = getUrl("analogBank")(mac_id);
  return trackPromise(Call.get(url));
};

export const sendAnalogBankAsync = ({mac_id}, payload) => {
  const url = getUrl("analogBank")(mac_id);
  return trackPromise(Call.post(url, payload));
};

export const requestFavouriteAsync = ({mac_id}) => {
  const url = getUrl("favourite")(mac_id);
  return trackPromise(Call.get(url));
};

export const sendFavouriteAsync = ({mac_id}, payload) => {
  const url = getUrl("favourite")(mac_id);
  return trackPromise(Call.patch(url, payload));
};

export const requestFavouritesAsync = () => {
  const url = getUrl("favourites")();
  return trackPromise(Call.get(url));
};

export const requestSnapshotAsync = ({mac_id, pageUrl = ""}) => {
  const url = pageUrl ? pageUrl : getUrl("dashboards");
  return trackPromise(CallV2.get(url, {params: {controller_pk: mac_id}}));
};

export const resetControllerAsync = (mac) => {
  const url = getUrl("resetController")(mac);
  return trackPromise(Call.post(url));
};

export const getCategories = () => {
  let url = getUrl("applianceCategory");
  return trackPromise(CallV2.get(url));
};

export const getGroupsByCategoryAsync = (appliance_category) => {
  const url = getUrl("sensorGroups");
  return trackPromise(CallV2.get(url, {params: {all: true, appliance_category}}));
};
export const getTypesAsync = (appliance_category) => {
  const url = getUrl("sensorTypes");
  return trackPromise(CallV2.get(url, {params: {all: true, appliance_category}}));
};

export const getGroupsAsync = ({mac_id}) => {
  const url = getUrl("sensorGroups");
  return trackPromise(CallV2.get(url, {params: {all: true, controller_pk: mac_id}}));
};

export const getSelectedGroupTypeAsync = ({sensorId}) => {
  const url = getUrl("selectedSensorGroupType")(sensorId);
  return trackPromise(CallV2.get(url));
};

export const updateSensorGroupTypeAsync = ({sensorId}, payload) => {
  const url = getUrl("selectedSensorGroupType")(sensorId);
  return trackPromise(CallV2.patch(url, payload));
};

export const getControllersWithActiveAlertAsync = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("controllersWithActiveAlert");
  return trackPromise(Call.get(url));
};

export const getControllerSensorDataAsync = () => {
  const url = getUrl("controllerSensorData");
  return trackPromise(CallV2.get(url));
};
